import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Label, Row } from 'reactstrap';
import { Toggle } from 'components/Common/Toggle';
import { Select } from 'components/Common';
import styled from 'styled-components';
import { HelpText } from 'components/HelpText';

const APPLICANT_QUANTITY_OPTIONS = [1, 2, 3, 4, 5].map(i => ({
  label: i,
  value: i,
}));

const StyledHelpText = styled.span`
  font-size: 11px;
  color: #dc3545;
  display: block;
  margin-top: 2px;
`;

export const OrderTypeEditApplicant = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const toggleCheckbox = field => {
    formik.setFieldValue(field, !formik.values[field]);
  };

  return (
    <>
      {/* Applicant Section Header */}
      <Row className="d-flex mt-3 flex-wrap align-items-center py-2 border-bottom">
        <Col xs={12} className="p-0">
          <Label className="m-0 fw-semibold" style={{ fontSize: '14px' }}>
            Applicant Settings
          </Label>
        </Col>
      </Row>

      {/* Quantity */}
      <Row className="d-flex mt-3 flex-wrap align-items-center py-2">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            Quantity
            <HelpText size="sm" noBackground hideIcon>
              Maximum number of applicants allowed
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={4} className="p-0">
          <Select
            menuPlacement="auto"
            options={APPLICANT_QUANTITY_OPTIONS}
            value={APPLICANT_QUANTITY_OPTIONS.find(
              option => option.value === formik.values.applicantMaxQuantity,
            )}
            className="vbo-select"
            classNamePrefix="react-select"
            onChange={val =>
              formik.setFieldValue('applicantMaxQuantity', val.value)
            }
            style={{ maxWidth: '100px' }}
          />
        </Col>
      </Row>

      {/* Birthdate */}
      <Row className="d-flex mt-2 flex-wrap align-items-center py-2">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            Birthdate
            <HelpText size="sm" noBackground hideIcon>
              Enable birthdate field for applicants
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={4} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableApplicantBirthdate}
            onChange={() => toggleCheckbox('enableApplicantBirthdate')}
            label=""
          />
        </Col>
      </Row>

      {/* Passport */}
      <Row className="d-flex mt-2 flex-wrap align-items-center py-2">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            Passport
            <HelpText size="sm" noBackground hideIcon>
              Enable passport field for applicants
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={4} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableApplicantPassport}
            onChange={() => toggleCheckbox('enableApplicantPassport')}
            label=""
          />
        </Col>
      </Row>

      {/* Contact Person */}
      <Row className="d-flex mt-3 flex-wrap align-items-center py-2 border-top">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            {t('orderTypes.enableContactPerson')}
            <HelpText size="sm" noBackground hideIcon>
              Enable contact person field
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={4} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableContactPerson}
            onChange={() => toggleCheckbox('enableContactPerson')}
            label=""
          />
        </Col>
      </Row>

      {/* Residency */}
      <Row className="d-flex mt-2 flex-wrap align-items-center py-2">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            {t('orderTypes.enableResidency')}
            <HelpText size="sm" noBackground hideIcon>
              Enable residency information
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={4} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableResidency}
            onChange={() => toggleCheckbox('enableResidency')}
            label=""
          />
          <StyledHelpText>⚠️ {'Must activate passport.'}</StyledHelpText>
        </Col>
      </Row>

      {/* Description */}
      <Row className="d-flex mt-2 flex-wrap align-items-center py-2">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            {t('orderTypes.enableDescription')}
            <HelpText size="sm" noBackground hideIcon>
              Enable description field
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={4} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableDescription}
            onChange={() => toggleCheckbox('enableDescription')}
            label=""
          />
        </Col>
      </Row>
    </>
  );
};
